import { render, staticRenderFns } from "./adres.vue?vue&type=template&id=4acaaaf8&scoped=true"
import script from "./adres.vue?vue&type=script&lang=js"
export * from "./adres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acaaaf8",
  null
  
)

export default component.exports